<template>
    <div class="popularPicks-wrapper">
        <div class="main">
            <div class="title">熱門精選</div>
            <div class="list flex-bt">
                <SmallNews v-for="(item, index) in list" :key="index" :data="item"></SmallNews>
            </div>
        </div>
    </div>
</template>
<script>
//熱門精選
//http://loopw7.w7ad.com/app/index.php?i=3&c=entry&m=tvp_appcenter&do=json&sjk=article&searchkey=class_type&searchvalue=%E7%86%B1%E9%96%80%E7%B2%BE%E9%81%B8&limit=8
import SmallNews from '@/components/SmallNews.vue'
export default {
    components: { SmallNews },
    data() {
        return {
            list: []
        }
    },
    mounted() {

        this.getList()
        // this.getCaseList()
    },
    methods: {
        async getList() {
            let fdata = { do: 'json', sjk: 'article', searchkey: 'iftuijian', searchvalue: '1', limit: 3 }
            let res = await this.$api.funk(fdata)
            this.list = res
        }
    }
}
</script>
<style lang="scss" scoped>
.popularPicks-wrapper {
    margin-top: 0.4rem;

    .title {
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 400;
        font-size: 0.24rem;
        line-height: 0.32rem;
        color: #000000;
    }

    .list {
        margin-top: 0.16rem;
    }
}

@media (max-width: 750px) {
    .popularPicks-wrapper .list {
        display: none;
    }

    .popularPicks-wrapper .title {
        font-size: 0.48rem;
        line-height: 0.48rem;
        margin-bottom: 0.4rem;
    }
}
</style>